import { createApiAction } from "services/api";
import {
  StartAction,
  SuccessAction,
  FailureAction,
} from "services/api/redux/types";

export enum UsersActionTypes {
  FETCH_ACTIVE_USER_START = "user/fetch_active_user_start",
  FETCH_ACTIVE_USER_SUCCESS = "user/fetch_active_user_success",
  FETCH_ACTIVE_USER_FAILURE = "user/fetch_active_user_failure",
}

// ACTIVE CUSTOMER

const fetchActiveUserActionStart = (): StartAction => ({
  type: UsersActionTypes.FETCH_ACTIVE_USER_START,
  payload: null,
});

const fetchActiveUserActionSuccess = (payload: any): SuccessAction => ({
  type: UsersActionTypes.FETCH_ACTIVE_USER_SUCCESS,
  payload,
});

const fetchActiveUserActionFailure = (error: string): FailureAction => ({
  type: UsersActionTypes.FETCH_ACTIVE_USER_FAILURE,
  payload: { error },
});

export const fetchActiveUser = () =>
  createApiAction(
    {
      path: "/v1/users/current",
      method: "GET",
    },
    fetchActiveUserActionStart,
    fetchActiveUserActionSuccess,
    fetchActiveUserActionFailure
  );
